import { merge } from "lodash";
import { LangUtils } from "../../edtell-portal/namespaces/lang-utils.namespace";
import { EdtellCacheModifierConfig } from "../interfaces/edtell-cache-config.interface";
import { EdtellCacheUtil } from "../namespaces/edtell-cache-utils.namespace";

export function EdtellCacheModifier(config: EdtellCacheModifierConfig) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    const fn = descriptor.value;
    descriptor.value = (...args: any[]) => {
      const result = fn(...args);

      // Transform the result, so we are always dealing with a promise
      const prom: Promise<any> = LangUtils.toPromise(result);
      prom.then(async (r) => {
        // Get Class Cache
        const api = EdtellCacheUtil.getCacheApi(target);
        const cache = api.getCacheByMethodName(config.targetMethod);

        // Clears the cache if no compare method is defined
        if (config.comareFn == null) {
          cache.clear();
          return;
        } else {
          // Compares all the elements to see if any need to be updated
          for (const k of cache.keys()) {
            const cachedElm = await LangUtils.toPromise(cache.get(k));
            if (config.comareFn(r, cachedElm)) {
              switch (config.strategy) {
                case "MERGE": {
                  merge(cachedElm, r);
                  break;
                }
                case "REPLACE": {
                  cache.replace(k, result);
                  break;
                }
                case "ADD": {
                  cache.add(k, result);
                  break;
                }
                default: {
                  cache.remove(k);
                }
              }
            }
          }
        }
      });

      return result;
    };
  };
}
